module.exports = __webpack_public_path__ + "static/media/11.d0a16170.jpg";